// extracted by mini-css-extract-plugin
export default {"root":"G0kJ1BavE1p_NiAOtkAj","nameContainer":"Tgs0fCR6pHRvGlfqr2cf","textField":"V8sbwQ9SYtgAqsCFzUJ6"};